import { replace } from 'react-router-redux';
import { checkMemberData } from 'actions/member';
import { getGiftEventList, checkQualification } from 'actions/event';

export default store => ({
	path: 'event',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'event',
			),
		onEnter: ({ location: { query: { id = '' } } }) => {
			const { auth: { token: { accessToken } } } = store.getState();
			if (accessToken === '') {
				store.dispatch(replace('/login'));
			} else if (accessToken !== '') {
				store.dispatch(checkMemberData());
			}
			store.dispatch(getGiftEventList(id));
		},
	},
	childRoutes: [
		{
			path: ':id',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Home').default;
							cb(null, component);
						},
						'event',
					),
				onEnter: ({ location: { query: { id = '' } } }) => {
					const { auth: { token: { accessToken } } } = store.getState();
					if (accessToken === '') {
						store.dispatch(replace('/login'));
					}
					store.dispatch(getGiftEventList(id));
				},
			},
			childRoutes: [
				{
					path: ':id',
					indexRoute: {
						getComponent: (nextState, cb) =>
							require.ensure(
								[],
								require => {
									const component = require('./Form').default;
									cb(null, component);
								},
								'form',
							),
						onEnter: ({ params }) => {
							const { auth: { token: { accessToken } } } = store.getState();
							if (accessToken === '') {
								store.dispatch(replace('/login'));
							}
							store.dispatch(checkQualification(params.id[1], params.id[0], 'check'));
						},
					},
				},
			],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Event/index.js